<template>
  <base-section id="affiliates" space="50" class="marketing-executive-section">
    <v-container>
      <base-section-heading title="Marketing Executive" />

      <v-card class="marketing-search-card" flat>
        <div class="marketing-search-top">
          <div class="marketing-search-hero">
            <p class="marketing-search-eyebrow">Verifikasi Data</p>
            <h3 class="marketing-search-title">
              Cek apakah Marketing Executive terdaftar
            </h3>
            <p class="marketing-search-description">
              Masukkan Nama atau Nomor Lisensi untuk memastikan data Marketing
              Executive tersedia.
            </p>
            <div class="marketing-search-tags">
              <span class="marketing-search-tag">Nama</span>
              <span class="marketing-search-tag">Nomor Lisensi</span>
            </div>
          </div>

          <div class="marketing-search-aside text-center">
            <span class="marketing-search-aside__label">Hasil Pencarian</span>
            <strong class="marketing-search-aside__count">
              {{ hasSearched ? searchResults.length : "-" }}
            </strong>
            <p class="marketing-search-aside__text">
              data sesuai pencarian terakhir
            </p>
          </div>
        </div>

        <div class="marketing-search-shell">
          <div class="marketing-search-shell__header">
            <div>
              <p class="marketing-search-shell__eyebrow">
                VALIDASI MARKETING EXECUTIVE
              </p>
            </div>
          </div>

          <v-form class="marketing-search-form" @submit.prevent="submitSearch">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              placeholder=" Masukkan, Nama atau Nomor Lisensi"
              solo
              flat
              hide-details
              class="marketing-search-input"
              @keyup.enter="submitSearch"
            />
            <v-btn
              color="primary"
              large
              class="marketing-search-button"
              :loading="loading"
              @click="submitSearch"
            >
              <v-icon left small>mdi-shield-check-outline</v-icon>
              Cek Data
            </v-btn>
          </v-form>
        </div>

        <div v-if="hasSearched" class="marketing-search-result">
          <div
            class="marketing-search-status"
            :class="
              searchResults.length
                ? 'marketing-search-status--found'
                : 'marketing-search-status--empty'
            "
          >
            <div class="marketing-search-status__icon">
              <v-icon large>
                {{
                  searchResults.length
                    ? "mdi-check-decagram"
                    : "mdi-alert-circle-outline"
                }}
              </v-icon>
            </div>
            <div class="marketing-search-status__body">
              <div class="marketing-search-status__meta">
                <span class="marketing-search-status__chip">
                  {{
                    searchResults.length ? "Terverifikasi" : "Tidak Ditemukan"
                  }}
                </span>
                <span class="marketing-search-status__keyword">
                  {{ submittedSearch }}
                </span>
              </div>
              <h4 class="marketing-search-status__title">
                {{
                  searchResults.length
                    ? "Data Marketing Executive ditemukan"
                    : "Data Marketing Executive tidak ditemukan"
                }}
              </h4>
              <p class="marketing-search-status__text">
                {{
                  searchResults.length
                    ? `Ditemukan ${searchResults.length} data yang sesuai dengan pencarian "${submittedSearch}".`
                    : `Tidak ada data yang cocok dengan pencarian "${submittedSearch}".`
                }}
              </p>
            </div>
          </div>

          <div v-if="searchResults.length" class="marketing-search-result-list">
            <v-card
              v-for="item in searchResults"
              :key="item.marketingexecutive_id"
              flat
              class="marketing-result-card"
              :class="{
                'marketing-result-card--inactive': !hasActiveLicense(item)
              }"
            >
              <div class="marketing-result-card__hero">
                <div class="marketing-result-card__headline">
                  <p class="marketing-result-card__label">
                    Marketing Executive
                  </p>
                  <h4 class="marketing-result-card__name">
                    {{ item.marketingexecutive_name }}
                  </h4>
                  <p class="marketing-result-card__subtext">
                    Data identitas berhasil ditemukan pada database verifikasi.
                  </p>
                </div>
                <div
                  class="marketing-result-card__verify"
                  :class="{
                    'marketing-result-card__verify--inactive': !hasActiveLicense(
                      item
                    )
                  }"
                >
                  <span class="marketing-result-card__verify-label"
                    >Status</span
                  >
                  <strong class="marketing-result-card__verify-value">
                    {{
                      hasActiveLicense(item) ? "Aktif Terdaftar" : "Tidak Aktif"
                    }}
                  </strong>
                  <span class="marketing-result-card__id">
                    ID {{ item.marketingexecutive_id }}
                  </span>
                </div>
              </div>

              <div class="marketing-result-card__grid">
                <div class="marketing-result-card__item">
                  <span class="marketing-result-card__item-label">
                    <v-icon small color="#355c7d"
                      >mdi-office-building-outline</v-icon
                    >
                    Kantor Pemasaran/Mitra Layanan
                  </span>
                  <span class="marketing-result-card__item-value">
                    {{ item.marketingexecutive_branchdesc || "-" }}
                  </span>
                </div>
                <div class="marketing-result-card__item">
                  <span class="marketing-result-card__item-label">
                    <v-icon small color="#355c7d"
                      >mdi-card-account-details-outline</v-icon
                    >
                    Nomor Lisensi AASI
                  </span>
                  <span class="marketing-result-card__item-value">
                    {{ item.marketingexecutive_lisenceno || "-" }}
                  </span>
                </div>
                <div class="marketing-result-card__item">
                  <span class="marketing-result-card__item-label">
                    <v-icon small color="#355c7d"
                      >mdi-calendar-check-outline</v-icon
                    >
                    Tanggal Terbit
                  </span>
                  <span class="marketing-result-card__item-value">
                    {{ item.marketingexecutive_lisencedate || "-" }}
                  </span>
                </div>
                <div class="marketing-result-card__item">
                  <span class="marketing-result-card__item-label">
                    <v-icon small color="#355c7d"
                      >mdi-calendar-clock-outline</v-icon
                    >
                    Tanggal Expired
                  </span>
                  <span class="marketing-result-card__item-value">
                    {{ item.marketingexecutive_lisenceexpiry || "-" }}
                  </span>
                </div>
              </div>
            </v-card>
          </div>
        </div>
      </v-card>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionMarketingExecutive",
  data: () => ({
    search: "",
    submittedSearch: "",
    hasSearched: false,
    loading: false,
    searchResults: []
  }),
  methods: {
    formatDateIndo(date) {
      if (!date) {
        return "";
      }

      const cleanDate = String(date).trim();
      const monthNamesByNumber = {
        "01": "Januari",
        "02": "Februari",
        "03": "Maret",
        "04": "April",
        "05": "Mei",
        "06": "Juni",
        "07": "Juli",
        "08": "Agustus",
        "09": "September",
        "10": "Oktober",
        "11": "November",
        "12": "Desember"
      };
      const yearFirstMatch = cleanDate.match(/^(\d{4})[-/](\d{2})[-/](\d{2})/);
      const dayFirstMatch = cleanDate.match(/^(\d{2})[-/](\d{2})[-/](\d{4})/);
      const namedMonthMatch = cleanDate.match(
        /^(\d{4})\s+([A-Za-z]+)\s+(\d{1,2})$/i
      );

      if (yearFirstMatch) {
        const [, year, month, day] = yearFirstMatch;
        return `${day} ${monthNamesByNumber[month]} ${year}`;
      }

      if (dayFirstMatch) {
        const [, day, month, year] = dayFirstMatch;
        return `${day} ${monthNamesByNumber[month]} ${year}`;
      }

      if (namedMonthMatch) {
        const [, year, monthName, day] = namedMonthMatch;
        return `${day} ${monthName} ${year}`;
      }

      return cleanDate;
    },
    normalizeMarketingExecutive(item) {
      return {
        ...item,
        marketingexecutive_lisencedate: this.formatDateIndo(
          item.marketingexecutive_lisencedate
        ),
        marketingexecutive_lisenceexpiry: this.formatDateIndo(
          item.marketingexecutive_lisenceexpiry
        )
      };
    },
    dedupeMarketingExecutives(items) {
      const uniqueItems = new Map();

      items.forEach(item => {
        const normalizedItem = this.normalizeMarketingExecutive(item);

        if (!this.hasActiveLicense(normalizedItem)) {
          return;
        }

        const itemId = String(
          normalizedItem.marketingexecutive_id || ""
        ).trim();

        if (!itemId) {
          return;
        }

        if (!uniqueItems.has(itemId)) {
          uniqueItems.set(itemId, normalizedItem);
          return;
        }
      });

      return Array.from(uniqueItems.values());
    },
    hasActiveLicense(item) {
      const license = String(item.marketingexecutive_lisenceno || "")
        .replace(/\s+/g, "")
        .trim();

      return license !== "" && !/^0+$/.test(license);
    },
    submitSearch() {
      const keyword = this.search.trim();

      if (!keyword) {
        this.submittedSearch = "";
        this.hasSearched = false;
        this.searchResults = [];
        return;
      }

      this.submittedSearch = keyword;
      this.hasSearched = true;
      this.loadMarketingExecutive();
    },
    buildSearchPayload() {
      const keyword = this.submittedSearch.trim();
      const formdata = {
        order_by: "marketingexecutive_name",
        order_type: "ASC"
      };

      const isMarketingExecutiveId = !/\s/.test(keyword);

      if (isMarketingExecutiveId) {
        formdata.marketingexecutive_id = keyword;
      } else {
        formdata.marketingexecutive_name = keyword;
      }

      return formdata;
    },
    buildSearchQuery(formdata) {
      const query = ["order_by=marketingexecutive_name", "order_type=ASC"];

      if (formdata.marketingexecutive_id) {
        query.push(
          `marketingexecutive_id=${encodeURIComponent(
            formdata.marketingexecutive_id
          )}`
        );
      }

      if (formdata.marketingexecutive_name) {
        query.push(
          `marketingexecutive_name=${encodeURIComponent(
            formdata.marketingexecutive_name
          )}`
        );
      }

      return query.join("&");
    },
    loadMarketingExecutive() {
      const formdata = this.buildSearchPayload();
      const searchQuery = this.buildSearchQuery(formdata);
      const param = this.$functions.ParamPOST(formdata);

      this.loading = true;
      this.$axios
        .post(
          this.$functions.SafeURL("apiListMarketingExecutive", searchQuery),
          param,
          {
            headers: {
              "Content-Type": "text/plain; charset=ISO-8859-1"
            }
          }
        )
        .then(response => {
          const feedback = Array.isArray(response.data) ? response.data : [];
          if (
            feedback.length > 0 &&
            typeof feedback[0].feedback !== "undefined" &&
            feedback[0].feedback !== "Y"
          ) {
            this.searchResults = [];
            return;
          }

          this.searchResults = this.dedupeMarketingExecutives(feedback);
        })
        .catch(e => {
          this.searchResults = [];
          alert(e);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.marketing-executive-section {
  background: radial-gradient(
      circle at top right,
      rgba(53, 92, 125, 0.12),
      transparent 28%
    ),
    linear-gradient(180deg, #f4f8fc 0%, #edf3f8 100%);
}

.marketing-search-card {
  position: relative;
  overflow: hidden;
  padding: 34px;
  border: 1px solid rgba(76, 104, 132, 0.12);
  border-radius: 32px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(248, 251, 254, 0.98) 100%
  );
  box-shadow: 0 26px 54px rgba(39, 58, 80, 0.1);
}

.marketing-search-card::before {
  content: "";
  position: absolute;
  top: -120px;
  right: -80px;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(53, 92, 125, 0.12) 0%,
    transparent 68%
  );
  pointer-events: none;
}

.marketing-search-top {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 240px;
  gap: 24px;
  align-items: stretch;
}

.marketing-search-hero {
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
}

.marketing-search-eyebrow {
  margin: 0 0 8px;
  color: #44627d;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.marketing-search-title {
  max-width: 720px;
  margin: 0 0 12px;
  color: #17324d;
  font-size: 2.05rem;
  font-weight: 700;
  line-height: 1.15;
}

.marketing-search-description {
  max-width: 700px;
  margin: 0;
  color: #5f7183;
  font-size: 0.98rem;
  line-height: 1.7;
}

.marketing-search-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 18px;
}

.marketing-search-tag {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid rgba(76, 104, 132, 0.12);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.76);
  color: #4e6984;
  font-size: 0.82rem;
  font-weight: 700;
}

.marketing-search-aside {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 188px;
  padding: 22px;
  border: 1px solid rgba(53, 92, 125, 0.14);
  border-radius: 26px;
  background: linear-gradient(160deg, #17324d 0%, #355c7d 100%);
  color: #fff;
  box-shadow: 0 18px 34px rgba(23, 50, 77, 0.18);
}

.marketing-search-aside__label {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.8;
}

.marketing-search-aside__count {
  display: block;
  margin: 10px 0 6px;
  font-size: 3rem;
  font-weight: 800;
  line-height: 1;
}

.marketing-search-aside__text {
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.92rem;
  line-height: 1.6;
}

.marketing-search-shell {
  position: relative;
  z-index: 1;
  margin-top: 6px;
  padding: 18px;
  border: 1px solid rgba(76, 104, 132, 0.1);
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.marketing-search-shell__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.marketing-search-shell__eyebrow {
  margin: 0 0 6px;
  color: #6b8198;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.marketing-search-shell__title {
  margin: 0;
  color: #21384f;
  font-size: 1.06rem;
  font-weight: 700;
}

.marketing-search-shell__hint {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 999px;
  background: #edf3f8;
  color: #4d6985;
  font-size: 0.8rem;
  font-weight: 700;
}

.marketing-search-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 14px;
  align-items: center;
}

.marketing-search-input {
  margin-top: 0;
}

::v-deep .marketing-search-input .v-input__control .v-input__slot {
  min-height: 62px !important;
  padding: 0 18px !important;
  border-radius: 18px !important;
  background: #fff !important;
  box-shadow: inset 0 0 0 1px rgba(76, 104, 132, 0.12) !important;
}

::v-deep .marketing-search-input .v-input__prepend-inner {
  margin-top: 18px !important;
  margin-right: 8px !important;
}

::v-deep .marketing-search-input input {
  color: #22313f !important;
}

::v-deep .marketing-search-input input::placeholder {
  color: #8a9aae !important;
}

.marketing-search-button {
  min-width: 170px;
  height: 62px !important;
  border-radius: 18px;
  background: linear-gradient(135deg, #17324d 0%, #244b71 100%) !important;
  text-transform: none;
  letter-spacing: 0.01em;
  font-weight: 700;
  box-shadow: 0 16px 28px rgba(23, 50, 77, 0.18) !important;
}

.marketing-search-result {
  margin-top: 24px;
}

.marketing-search-status {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 18px;
  align-items: start;
  padding: 22px 24px;
  border-radius: 24px;
}

.marketing-search-status--found {
  background: linear-gradient(180deg, #eff8f3 0%, #fbfdfc 100%);
  border: 1px solid rgba(55, 138, 95, 0.16);
  color: #21613f;
}

.marketing-search-status--empty {
  background: linear-gradient(180deg, #fff5f4 0%, #fffafa 100%);
  border: 1px solid rgba(197, 61, 54, 0.16);
  color: #9f312b;
}

.marketing-search-status__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.72);
}

.marketing-search-status__body {
  min-width: 0;
}

.marketing-search-status__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.marketing-search-status__chip,
.marketing-search-status__keyword {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
}

.marketing-search-status__chip {
  background: rgba(255, 255, 255, 0.84);
}

.marketing-search-status__keyword {
  background: rgba(255, 255, 255, 0.58);
}

.marketing-search-status__title {
  margin: 0 0 6px;
  font-size: 1.14rem;
  font-weight: 700;
}

.marketing-search-status__text {
  margin: 0;
  font-size: 0.94rem;
  line-height: 1.6;
}

.marketing-search-result-list {
  display: grid;
  gap: 18px;
  margin-top: 20px;
}

.marketing-result-card {
  position: relative;
  overflow: hidden;
  padding: 26px;
  border: 1px solid rgba(76, 104, 132, 0.12);
  border-radius: 28px;
  background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
  box-shadow: 0 18px 34px rgba(39, 58, 80, 0.08);
}

.marketing-result-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, #244b71 0%, #4b88c7 100%);
}

.marketing-result-card--inactive::before {
  background: linear-gradient(90deg, #7e8b97 0%, #b1bac2 100%);
}

.marketing-result-card__hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 22px;
}

.marketing-result-card__headline {
  max-width: 680px;
}

.marketing-result-card__label {
  margin: 0 0 6px;
  color: #597996;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.marketing-result-card__name {
  margin: 0 0 10px;
  color: #18324d;
  font-size: 1.34rem;
  font-weight: 700;
}

.marketing-result-card__subtext {
  margin: 0;
  color: #607488;
  font-size: 0.92rem;
  line-height: 1.6;
}

.marketing-result-card__verify {
  display: grid;
  gap: 6px;
  min-width: 190px;
  padding: 16px;
  border-radius: 20px;
  background: linear-gradient(160deg, #17324d 0%, #2a5074 100%);
  box-shadow: 0 14px 24px rgba(23, 50, 77, 0.16);
}

.marketing-result-card__verify--inactive {
  background: linear-gradient(160deg, #6f7f8f 0%, #8a98a5 100%);
  box-shadow: 0 14px 24px rgba(87, 101, 113, 0.14);
}

.marketing-result-card__verify-label {
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.marketing-result-card__verify-value {
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
}

.marketing-result-card__id {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 7px 11px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.8rem;
  font-weight: 700;
}

.marketing-result-card__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.marketing-result-card__item {
  display: grid;
  gap: 10px;
  padding: 18px;
  border: 1px solid rgba(76, 104, 132, 0.08);
  border-radius: 18px;
  background: linear-gradient(180deg, #fbfdff 0%, #f4f8fc 100%);
}

.marketing-result-card__item-label {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #69829b;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.marketing-result-card__item-value {
  color: #253747;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.5;
}

@media (max-width: 960px) {
  .marketing-search-card {
    padding: 24px;
    border-radius: 26px;
  }

  .marketing-search-top {
    grid-template-columns: 1fr;
  }

  .marketing-search-title {
    font-size: 1.7rem;
  }

  .marketing-search-hero {
    margin-bottom: 18px;
  }

  .marketing-search-aside {
    min-height: 0;
  }

  .marketing-search-form {
    grid-template-columns: 1fr;
  }

  .marketing-search-button {
    width: 100%;
  }

  .marketing-result-card__grid {
    grid-template-columns: 1fr;
  }

  .marketing-result-card__hero {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .marketing-search-card {
    padding: 18px 14px;
    border-radius: 20px;
  }

  .marketing-search-title {
    font-size: 1.36rem;
  }

  .marketing-search-description {
    font-size: 0.92rem;
    line-height: 1.6;
  }

  .marketing-search-tags {
    gap: 8px;
  }

  .marketing-search-tag {
    font-size: 0.76rem;
  }

  .marketing-search-aside {
    padding: 18px;
    border-radius: 20px;
  }

  .marketing-search-aside__count {
    font-size: 2.4rem;
  }

  .marketing-search-shell {
    padding: 14px;
    border-radius: 20px;
  }

  .marketing-search-shell__header {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 12px;
  }

  .marketing-search-status {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 16px;
    border-radius: 16px;
  }

  .marketing-result-card {
    padding: 16px;
    border-radius: 22px;
  }

  .marketing-result-card__name {
    font-size: 1.16rem;
  }

  .marketing-result-card__verify {
    width: 100%;
    min-width: 0;
    padding: 14px;
    border-radius: 18px;
  }

  .marketing-result-card__item {
    padding: 14px;
    border-radius: 14px;
  }
}
</style>
